import { RootState } from '../../reducers';

export const selectSortOptions = (state: RootState) =>
  state.playlistSelector.sortOptions;

export const selectSearchQuery = (state: RootState) =>
  state.playlistSelector.searchQuery;
